import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/styles";
import { MobileCardItem } from "../../../../MoleculesMobile/CardItem";
import { MobileDialogCampusGroupAttendance } from "../../../Dialogs/Campus/Group/Attendance";
var useStyles = makeStyles(function (theme) {
  return {
    searchContainer: {
      display: "flex",
      flexFlow: "row nowrap",
      alignItems: "center",
      height: "60px",
      paddingTop: "8px",
      position: "fixed",
      width: "100%",
      zIndex: "10",
      background: theme.palette.background["default"]
    },
    search: {
      borderRadius: "60px",
      margin: "0 8px"
    },
    content: {
      padding: "80px 0 12px 0",
      width: "100%"
    },
    m12: {
      margin: "12px"
    },
    defaultCard: {
      margin: "12px",
      padding: "8px 4px"
    }
  };
});

var MobileCampusGroupTabAttendance = function MobileCampusGroupTabAttendance(props) {
  var classes = useStyles();

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      arrCollapse = _useState2[0],
      setArrCollapse = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      userSelected = _useState4[0],
      setUserSelected = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      openDialogGroupAttendance = _useState6[0],
      setOpenDialogGroupAttendance = _useState6[1]; // HANDLE DIALOG


  var handleDialogGroupAttendance = function handleDialogGroupAttendance() {
    if (openDialogGroupAttendance) {
      setOpenDialogGroupAttendance(!openDialogGroupAttendance);
      setUserSelected(null);
    } else {
      setOpenDialogGroupAttendance(!openDialogGroupAttendance);
    }
  }; // CHECK COLLAPSE AND ADD NEW ITEMS


  useEffect(function () {
    var auxArr = [];
    props.data.forEach(function (attendance) {
      var auxAttendanceCollapse = arrCollapse.find(function (attendanceCollapse) {
        return attendanceCollapse._id === attendance._id;
      });

      if (auxAttendanceCollapse) {
        auxArr.push(auxAttendanceCollapse);
      } else {
        auxArr.push({
          _id: attendance._id,
          open: false
        });
      }
    });
    setArrCollapse(auxArr);
  }, [props.data]); // INITIALIZE COLLAPSE FALSE

  useEffect(function () {
    var auxArr = [];
    props.data.forEach(function (attendance) {
      auxArr.push({
        _id: attendance._id,
        open: false
      });
    });
    setArrCollapse(auxArr);
  }, []); // HANDLE COLLAPSE ATTENDANCE

  var handleCollapse = function handleCollapse(id) {
    var newArrCollapse = arrCollapse.map(function (attendance) {
      if (attendance._id === id) {
        return _objectSpread(_objectSpread({}, attendance), {}, {
          open: !attendance.open
        });
      } else {
        return attendance;
      }
    });
    setArrCollapse(newArrCollapse);
  }; // HANDLE CLICK USER TO SHOW DIALOG


  var handleClickUser = function handleClickUser(key, id) {
    var attendanceSelected = props.data.find(function (attendance) {
      return attendance._id === id;
    });

    if (attendanceSelected) {
      var auxUserselected = attendanceSelected.attendance.users.find(function (user) {
        return user.key === key;
      });

      if (auxUserselected) {
        setUserSelected(_objectSpread(_objectSpread({}, auxUserselected), {}, {
          date: attendanceSelected.date
        }));
        handleDialogGroupAttendance();
      }
    }
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MobileDialogCampusGroupAttendance, {
    open: openDialogGroupAttendance,
    onClose: handleDialogGroupAttendance,
    data: userSelected,
    translation: props.translation && props.translation.dialog ? props.translation.dialog : null
  }), props.data.map(function (attendance) {
    return /*#__PURE__*/React.createElement(MobileCardItem, {
      classes: classes.m12,
      template: "groupAttendanceListStaff",
      data: _objectSpread(_objectSpread({}, attendance), {}, {
        open: arrCollapse.find(function (collapseItem) {
          return collapseItem._id === attendance._id;
        }) ? arrCollapse.find(function (collapseItem) {
          return collapseItem._id === attendance._id;
        }).open : false,
        handleCollapse: handleCollapse,
        handleClickUser: handleClickUser
      })
    });
  }));
};

export { MobileCampusGroupTabAttendance };